import { render, staticRenderFns } from "./DataCorrectionTaskQueueLevel1.vue?vue&type=template&id=22441e0e&scoped=true&"
import script from "./DataCorrectionTaskQueueLevel1.vue?vue&type=script&lang=js&"
export * from "./DataCorrectionTaskQueueLevel1.vue?vue&type=script&lang=js&"
import style0 from "./DataCorrectionTaskQueueLevel1.vue?vue&type=style&index=0&id=22441e0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22441e0e",
  null
  
)

export default component.exports